const addDownloadIcon = (operationsList, downloadImage) => {

        const existingDownloadIcon = operationsList.querySelector('.anticon-download');
        if (existingDownloadIcon) {
            return; 
        }
        const downloadLi = document.createElement('li');
        downloadLi.className = 'ant-image-preview-operations-operation';

        const iconSpan = document.createElement('span');
        iconSpan.setAttribute('role', 'img');
        iconSpan.setAttribute('aria-label', 'download');
        iconSpan.className = 'anticon anticon-download ant-image-preview-operations-icon';

        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '64 64 896 896');
        svg.setAttribute('focusable', 'false');
        svg.setAttribute('data-icon', 'download');
        svg.setAttribute('width', '1em');
        svg.setAttribute('height', '1em');
        svg.setAttribute('fill', 'currentColor');
        svg.setAttribute('aria-hidden', 'true');

        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z');

        svg.appendChild(path);
        iconSpan.appendChild(svg);
        downloadLi.appendChild(iconSpan);

        downloadLi.addEventListener('click', downloadImage);
        operationsList.appendChild(downloadLi);
    }


export const addDownloadIconObserver = (handleDownload) => {
  const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.addedNodes.length) {
                    // Check if an image preview was added or modified
                    const previewOperations = document.querySelectorAll('.ant-image-preview-operations');
                    previewOperations.forEach(function (operationsList) {
                        addDownloadIcon(operationsList, handleDownload);
                    });
                }
            });
    });

    // Start observing the document body for DOM changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });


  return observer;
};

export const getImgDisplayName = (render) => {
        if (render.display_name) {
            return render.display_name;
        }
        if (render.filename){
            return render.filename;
        }
        if(render.image_name){
            return render.image_name;
        }
        return `Untitled ${render.filename.split('.')[0].split('_')[1]}`;
}

export const showCustomToast = () => {
  const toast = document.createElement('div');
  toast.textContent = 'Downloading image...';
  toast.style.position = 'fixed';
  toast.style.top = '20px';
  toast.style.left = '50%';
  toast.style.transform = 'translateX(-50%)';
  toast.style.zIndex = '9999';
  toast.style.background = 'rgba(0, 0, 0, 0.75)';
  toast.style.color = 'white';
  toast.style.padding = '10px 20px';
  toast.style.borderRadius = '4px';
  toast.style.fontSize = '14px';
  toast.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.3)';
  document.body.appendChild(toast);

  setTimeout(() => toast.remove(), 2000);
};